/**
 * A site's zone in Cloudflare against the certificate on its node (P10,
 * ADR-0023). `flexible` and `off` send Cloudflare to the node over plain HTTP,
 * which the node redirects back to HTTPS — a loop for ever; `strict` in front
 * of a self-signed certificate is a 526. Checked by the worker, which also sets
 * the mode where it may, and shown on the site's page.
 */

/** Cloudflare's SSL modes for a zone, as 2d2s reports and sets them. */
export const ZONE_SSL_MODES = ['off', 'flexible', 'full', 'strict'] as const;
export type ZoneSslMode = (typeof ZONE_SSL_MODES)[number];

/** The mode a zone can have, given whether every site under it has a verifiable certificate. */
export function zoneModeFor(authenticated: boolean): 'strict' | 'full' {
  return authenticated ? 'strict' : 'full';
}

/** A mode the site cannot live with: a redirect loop, or a 526. */
export function zoneSslProblem(mode: string | null, authenticated: boolean): 'loop' | 'untrusted' | null {
  if (mode === 'flexible' || mode === 'off') return 'loop';
  if (mode === 'strict' && !authenticated) return 'untrusted';
  return null;
}
